<template>
    <admin-layout>

<!--        <template #toolbox>-->
<!--            <learning-path-toolbox/>-->
<!--        </template>-->

        <app-content-pane class="ml-3">
            <template #title>
                <div class="w-100 btn-danger p-3 subscription-required" style="display: none;">
                    This feature is part of the School Subscription. <a href="https://www.designforchange.us/contact-us">Contact Us for more details.</a>
                </div>
                <div class="px-4 pt-3">
                    <h1>Learning Paths</h1>
                    <nav>
                        <ol class="breadcrumb">
    <!--                            <li class="breadcrumb-item"><inertia-link :href="route('project.dashboard', {...global_url_params})">Change Projects</inertia-link></li>-->
                            <li class="breadcrumb-item active">Learning Paths are Student Action Project Templates. Select one and start a project for your students.</li>
                        </ol>
                    </nav>
                    <a v-if="current_user_is_free" href="https://www.designforchange.us/contact-us" target="_new" class="btn btn-danger float-lg-right mr-0 mr-lg-5 mb-0 excess-mt">
                        <img src="/images/icons/archive-light.svg" class="mr-1" alt="">
                        This feature is part of the School Subscription. Contact Us for more details.
                    </a>
                </div>
                <hr class="mb-0">
                <!-- Later on Teacher will also be able to create new paths -->
                <div v-if="is_admin" class="actions px-4 pt-3 d-flex">
                    <div class="form-group ml-auto">
                        <inertia-link :href="route('project.learning-path.create', {...global_url_params})"
                                      class="btn btn-primary d-flex align-items-center">
                            <img src="/images/icons/plus-circle-solid-light.svg" class="mr-1" alt="">
                            Create new Path
                        </inertia-link>
                    </div>
                </div>
            </template>

            <hr class="mt-0">

            <section>

                <div class="px-4 py-3">
                    <div class="row align-items-stretch">
                        <div v-for="path in paths" class="col-12 col-lg-4 d-flex">
                            <div class="card mb-4 w-100">
                                <inertia-link :href="$page.props.user.is_admin ? route('project.learning-path.edit', {path: path.id, ...global_url_params}) : route('project.learning-path.show', {path: path.id, ...global_url_params})">
                                    <img v-if="path.meta?.image?.preview_url" class="card-img" :src="uploads.image(path.meta.image.preview_url, {w: 480, h: 240})">
                                    <img v-else class="card-img" src="https://via.placeholder.com/480x240?text=NO+PREVIEW">
                                </inertia-link>

                                <div class="actions" v-if="is_admin">
                                    <a href="#" @click.prevent.stop="openSettings(path)">
                                        <img src="/images/icons/cog.svg" alt="">
                                    </a>
                                </div>

                                <a target="_blank" rel="noopener" class="sponsor" v-if="path.meta?.sponsor_logo" :href="path.meta?.sponsor_url">
                                    <img :src="uploads.image(path.meta.sponsor_logo.preview_url, {w: 50, h: 50})" alt="">
                                    <h2 v-if="path.meta?.sponsor_name">{{ path.meta.sponsor_name }}</h2>
                                </a>

                                <div class="card-header">
                                    <h5 class="my-1">{{ path.name }}</h5>
                                </div>
                                <div class="card-body">
                                    <markdown-text :content="path.meta?.description"/>
                                </div>
                                <div class="card-footer d-flex">

                                    <div class="btn-group">
                                        <inertia-link :href="route('project.learning-path.show', {path: path.id, ...global_url_params})"
                                                      :disabled="is_busy[path.id]"
                                                      class="btn btn-outline-primary a-center">Preview</inertia-link>

                                        <button v-if="current_user_is_free" @click="subscriptionRequired()" data-toggle="tooltip" data-placement="bottom" title="Tooltip on bottom" class="btn btn-outline-dark ml-3">Start New Project</button>

                                        <template v-if="$page.props.user.is_admin">
                                            <inertia-link :href="route('project.learning-path.edit', {path: path.id, ...global_url_params})"
                                                          :disabled="is_busy[path.id]"
                                                          class="btn btn-outline-primary a-center">Edit</inertia-link>
                                            <state-button class="btn"
                                                          :class="is_busy[path.id] ? 'btn-primary' : 'btn-outline-primary'"
                                                          :disabled="is_busy[path.id]"
                                                          :state="is_busy[path.id] ? 'busy' : ''"
                                                          @click="clone( path )">Clone</state-button>
                                        </template>
                                    </div>

                                    <inertia-link v-if="current_user_is_paid"
                                                  :href="route('project.create', {path: path.id, ...global_url_params})"
                                                  class="btn btn-primary ml-auto a-center">Create Project</inertia-link>

                                </div>
                            </div>

                        </div>

                        <div v-if="!paths.length">
                            Sorry we couldn't find any learning paths for you.
                        </div>

                    </div>
                </div>

            </section>

        </app-content-pane>


        <learning-path-settings-modal v-if="settings"
                                      :path="settings"
                                      :tenants="tenants"
                                      @close="closeSettings"
                                      @deleted="pathDeleted"/>

    </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import AppContentPane from "@/Components/AppContentPane";
import LearningPathToolbox from "@/Components/Toolbox/LearningPathToolbox";
import MarkdownText from "@/Components/Common/MarkdownText";
import uploads from "@/mixins/uploads";
import StateButton from "@/Components/Common/StateButton";
import Modal from "@/Components/Common/Modal";
import FileUploader from "@/Components/Common/FileUploader";
import utils from "@/mixins/utils";
import API from "@/API";
import LearningPathSettingsModal from "@/Components/LearningPath/LearningPathSettingsModal";

export default {
    name: "Index",
    components: {
        LearningPathSettingsModal,
        StateButton, AdminLayout, AppContentPane, FileUploader, LearningPathToolbox, MarkdownText, Modal},
    mixins: [uploads, utils],
    props: {
        paths: {
            type: Array,
            default: () => [],
        },
        tenants: {
            type: Array,
            default: () => [],
        }
    },

    data(){
        return {
            is_busy: {},
            settings: null,
        };
    },


    methods: {
        clone(path){
            this.$inertia.post(route('project.learning-path.clone', {path: path.id, ...this.global_url_params}), {}, {
                onBefore: () => {
                    this.is_busy[path.id] = true;
                },
                onFinish(){
                    this.is_busy[path.id] = false;
                }
            });
        },

        openSettings(path){
            this.settings = path;
        },

        closeSettings(){
            console.log('close');
            this.settings = null;
        },

        pathDeleted(path){
            this.$inertia.reload();
            this.closeSettings();
        },

        subscriptionRequired() {
            $('.subscription-required').slideDown('5000', function() {
            });
        }

    },

    mounted() {

        this.setTitle( `Learning Paths` );

    }

}
</script>

<style lang="scss" scoped>
.excess-mt{
    margin-top: -4.5em;
}

@media (min-width: 650px) and (max-width: 900px){
    .excess-mt{
        margin-top: 0.5rem;
        width: 100%;
    }
}

.a-center{
    display: flex;
    align-items: center;
}
.project{
    a{
        text-decoration: none;
        color: $primary;
    }
}
.card{
    position: relative;

    .actions{
        position: absolute;
        right: 0;
        top: 0;
        padding: 1rem;
        background: rgba(white, 0.7);
        backdrop-filter: blur(5px);
        border-radius: 0 .5rem 0 .5rem;
    }

    .sponsor{
        position: absolute;
        top: 0;
        left: 0;
        background: white;
        padding: 10px 20px;
        display: flex;
        align-items: center;
        gap: 10px;
        text-decoration: none;
        border-radius: .5rem 0 .5rem 0;
        background: rgba(white, 0.7);
        backdrop-filter: blur(5px);


        img{
            border-radius: 50%;
        }

        h2{
            margin-top: 5px;
            color: black;
            font-size: 16px;
        }

    }
}

.subscription-required {
    a {
        color:  white;
    }
}

</style>
